import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/common.css'
import axios from 'axios'

axios.defaults.timeout = 30 * 1000
createApp(App).use(router).mount('#app')
